import { render, staticRenderFns } from "./StepCurrent.vue?vue&type=template&id=5870b392&"
import script from "./StepCurrent.vue?vue&type=script&lang=js&"
export * from "./StepCurrent.vue?vue&type=script&lang=js&"
import style0 from "./StepCurrent.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports